import React from 'react';
import { CalendarDays, CalendarClock, CircleCheck } from 'lucide-react';
import { ProjectModel, ProjectStatus } from '../../../types/projects';
import { EditableDateField } from '../../../Components/EditableDateField';

interface ProjectDatesSectionProps {
    project: ProjectModel;
    onUpdateStartDate: (startDate: string) => Promise<void>;
    onUpdatePlannedEndDate: (plannedEndDate: string) => Promise<void>;
    onUpdateActualEndDate: (actualEndDate: string) => Promise<void>;
    submitting?: boolean;
    /** Extra metadata cells rendered on the same grid row (e.g. assignment) */
    children?: React.ReactNode;
}

export const ProjectDatesSection: React.FC<ProjectDatesSectionProps> = ({
    project,
    onUpdateStartDate,
    onUpdatePlannedEndDate,
    onUpdateActualEndDate,
    submitting = false,
    children,
}) => {
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '16px',
            marginBottom: '24px'
        }}>
            <EditableDateField
                value={project.startDate}
                onSave={onUpdateStartDate}
                label="Startdatum"
                icon={<CalendarDays size={14} />}
                required
                disabled={submitting}
            />
            <EditableDateField
                value={project.plannedEndDate}
                onSave={onUpdatePlannedEndDate}
                label="Planerat slutdatum"
                icon={<CalendarClock size={14} />}
                required
                min={project.startDate}
                disabled={submitting}
            />
            {project.status === ProjectStatus.COMPLETED && project.actualEndDate && (
                <EditableDateField
                    value={project.actualEndDate}
                    onSave={onUpdateActualEndDate}
                    label="Slutfört"
                    icon={<CircleCheck size={14} />}
                    required
                    disabled={submitting}
                />
            )}
            {children}
        </div>
    );
};
